<template>
	<h1>Ajouter un type de question</h1>
	<form @submit.prevent="submit" class="form-container">
		<div class="input-container">
			<label for="Difficulty">Type de question</label>
			<input
				type="text"
				class="form-control"
				v-model="form.name"
				id="QuestionType"
				placeholder="QuestionType"
			/>
			<p v-if="status !== ''" class="status">{{ status }}</p>
			<p class="errors">{{ errors }}</p>
		</div>

		<input class="submit dark" type="submit" value="Valider" />
	</form>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'

export default {
	data() {
		return {
			form: {
				name: '',
			},
			errors: '',
			status: ''
		}
	},
	methods: {
		submit() {
			authenticatedApiFetch(`/question-types/`, { method: 'POST', body: JSON.stringify(this.form) })
				.then(() => {
					this.status = 'Enregistré avec succès'
					this.form.name = ""
					setTimeout(() => {
						this.status = ''
					}, 2000)
				})
				.catch((error) => {
					this.errors = error
				})
		},

	},
}
</script>

<style>
</style>
